//Slider
const slider = document.getElementById('hal-slider');
const slides  = [...slider.querySelectorAll('.slide')];
const next = document.querySelectorAll('.next')
const prev = document.querySelectorAll('.prev')
const buttons = document.querySelectorAll('#slider-navigation .btn')
const cards = document.querySelectorAll('.services__card');

//Header Animation
const headerImage = document.querySelector('.header__image'); 
const headerHeadline = document.querySelector('h1');
const textOverlay = CSSRulePlugin.getRule('.header__headline h1:before'); 

const tl_header = new gsap.timeline() 
.from(headerImage, {duration: 1, y: '50px', opacity: 0}, 'start')
.from('.header__headline h1', {duration: 1, visibility: 'hidden'}, 'start')
.to(textOverlay, 1, {cssRule:{bottom: 0, }}, 'start')
.to(textOverlay, 1, {cssRule:{bottom: '150%'}},)
//HeaderAnimation End

let counter = 0;

buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
        counter = index;
        toggleSlide()
    })
});

prev.forEach(element => {
    element.addEventListener('click', () => {
        if (counter > 0) {
            counter--
        } else {
            counter = (slides.length - 1)
        }
        toggleSlide()
    })
});

next.forEach(element => {
    element.addEventListener('click', () => {
        if (counter < (slides.length - 1)) {
            counter++
        } else {
            counter = 0;
        }
        toggleSlide()
    })
})


function toggleSlide () {
    slides.forEach((slide) => {
        slide.classList.remove('slide--active')
    })
    buttons.forEach((button) => {
        button.classList.remove('active')
    })
    buttons[counter].classList.add('active')
    slides[counter].classList.toggle('slide--active')
    gsap.from('.slide--active .slide__text', {duration: 1, opacity: 0, y: 50})
    gsap.fromTo('.slide--active .slide__overlay', {x: 0}, {x: '-100%', ease: "circ.inOut", duration: 1.5})
}


//ScrollMagic
const controller = new ScrollMagic.Controller();

//TimeLines
const tl_slider = gsap.timeline()
.fromTo('.slide--active .slide__overlay', {x: 0}, {x: '-100%', ease: "circ.inOut", duration: 1.5}, 'start')
.from('.slide--active .slide__text', {duration: 1, opacity: 0, y: 50}, 'start');

const tl_service = gsap.timeline()
.staggerFrom('.services__card', 1.1, {opacity: 0, y: 50, 
    stagger: {
    from: 0,
    amount: 0.5
  }
})

const service_scene = new ScrollMagic.Scene({triggerElement: '#services'})
.setTween(tl_service)
.addTo(controller)
.reverse(false)

const slider_scene = new ScrollMagic.Scene({triggerElement: "#hal-slider", duration: 0})
.setTween(tl_slider)
.addTo(controller)
.reverse(false)

